module.exports = __webpack_public_path__ + "img/victor32.03ebc035.png";